export function pad(x, nb = 2, pc = "0") {
  let ret = "" + x;
  while (ret.length < nb) {
    ret = pc + ret;
  }

  return ret;
}
